/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './SearchField.scss'
import React from 'react'

function SearchField(props) {
  const className = props.className || ''
  const value = props.value || ''
  const placeholder = props.placeholder || '検索'
  const onChange = props.onChange || (() => {})
  return (
    <div className={`SearchField ${className}`}>
      <input type="text" name={props.name} placeholder={placeholder} value={value} onChange={onChange} />
    </div>
  )
}

export default SearchField
